import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { class: "main-menu" }
const _hoisted_6 = { class: "main-content" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("a", {
  href: "https://proip.info/tos",
  target: "_blank"
}, "The Terms of Service", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_11 = /*#__PURE__*/_createVNode("a", {
  href: "https://proip.info/privacy",
  target: "_blank"
}, "Privacy Policy", -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TheHeader = _resolveComponent("TheHeader")
  const _component_a_layout_header = _resolveComponent("a-layout-header")
  const _component_TheMenu = _resolveComponent("TheMenu")
  const _component_router_view = _resolveComponent("router-view")
  const _component_a_layout_content = _resolveComponent("a-layout-content")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")
  const _component_a_layout = _resolveComponent("a-layout")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, {
      style: {"min-height":"100vh"},
      breakpoint: "md"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_TheHeader)
            ])
          ]),
          _: 1
        }),
        (_ctx.checkSideBar === 'main')
          ? (_openBlock(), _createBlock(_component_a_layout_content, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_3, [
                  _createVNode("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode(_component_TheMenu)
                    ]),
                    _createVNode("div", _hoisted_6, [
                      _createVNode(_component_router_view)
                    ])
                  ])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.checkSideBar === 'auth')
          ? (_openBlock(), _createBlock(_component_a_layout_content, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_router_view)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_layout_footer, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { md: 16 }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 2020-" + _toDisplayString(_ctx.date.getFullYear()) + " © ProIP.info", 1 /* TEXT */),
                      _hoisted_8,
                      _hoisted_9,
                      _hoisted_10,
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, {
                    md: 8,
                    class: "support-mail"
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}